// The `BodyContent` component renders detailed information for a specific service using the
// `contentData` prop. It displays the service name as a heading and its associated body
// content in a markdown format using the `MarkDownDescription` component. This ensures
// flexibility and rich text formatting for service descriptions.

import { MarkDownDescription } from 'components/commercetools-ui/atoms/markdown/markdown';
import React from 'react';
import { ServiceContent } from 'types/next';

type ContentDataProps = {
  contentData: ServiceContent;
};

const BodyContent = ({ contentData }: ContentDataProps) => {
  return (
    <div className="mb-30">
      <h1
        className={`mb-30 
        ${contentData?.templateType === 'termsAndCondition' ? 'termsAndConditionservicesheading' : ''}
        ${contentData?.templateType === 'privacyPolicy' ? 'privacyPolicyservicesheading' : ''}
        ${contentData?.templateType === 'aboutUs' ? 'aboutUsheading' : ''}
         ${contentData?.templateType === 'antiSlavery' ? 'antislaveryservicesheading' : ''}
        ${contentData?.templateType === 'shopOnlineCollect' ? 'shopOnlineCollectHeading' : ''}
        ${contentData?.templateType === 'secureShopping' ? 'secureShoppingservicesheading' : ''}
          ${contentData?.templateType === 'clubGuarantee' ? 'clubGuaranteeservicesheading' : ''}
        `}
      >
        {contentData?.serviceName}
      </h1>

      <MarkDownDescription markdownText={contentData?.bodyContent} classname={`${contentData?.templateType}services`} />
    </div>
  );
};

export default BodyContent;
